














import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "home",
  components: {},
})
export default class cover extends Vue {}
